import React from "react";
import Header from "../Component/Header/Header";
import Footer from "../Component/Footer/Footer";
import ServiceMain from "../Component/ServiceMain/ServiceMain";

function Service() {
  return (
    <>
      <Header />
      <ServiceMain />
      <Footer />
    </>
  );
}

export default Service;
